import { action, makeObservable, observable } from "mobx";
import { ImpactsDashboardGridModel } from "./grid/ImpactsDashboardGrid_model";
import UserReportsApi, {
  UserReportsApi as IUserReportsApi
} from "../../../../services/api/v2/userReports/UserReports.api";
import { MapImpactLevelData, MapImpactProgressData } from "./Impacts_mapper";
import { NavigateFunction } from "react-router-dom";
import { EntityTypes, GridTypes } from "../../../../enums";

export class ImpactModel {
  @observable isLoading: boolean = true;
  @observable.ref gridImpacts = [];
  organisationId: number;
  userReportProvider: IUserReportsApi;
  gridModel: ImpactsDashboardGridModel;
  pieData: any;
  progressData: any[];

  constructor(
    organisationId: number,
    projectId: number,
    authUser: FP.Entities.IUser,
    columnDefs: FP.Entities.IColumnDef[],
    urlSearchParams: URLSearchParams,
    preSelectedItemIds: number[],
    gridType: EntityTypes | GridTypes,
    navigate: NavigateFunction,
    onFieldUpdate: () => Promise<void>
  ) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.gridModel = new ImpactsDashboardGridModel(
      organisationId,
      projectId,
      authUser,
      columnDefs,
      urlSearchParams,
      preSelectedItemIds,
      gridType,
      navigate,
      this.handleFieldUpdate
    );
    this.userReportProvider = UserReportsApi;
  }

  onMount = async () => {
    await this.gridModel.onMount();
    await this.loadImpacts();
  };

  onUnmount = () => {};

  onGridReady = (params: any) => {
    this.gridModel.setGridApi(params);
  };

  loadImpacts = async () => {
    let res = await this.userReportProvider.getUserImpacts(this.organisationId);
    if (!res) return;
    this.setImpacts(res.payload);
  };

  @action
  setImpacts = (impacts: any[]) => {
    this.pieData = MapImpactLevelData(impacts);
    this.progressData = MapImpactProgressData(impacts);
    this.gridImpacts = impacts;
    this.isLoading = false;
  };
  @action
  handleFieldUpdate = async () => {
    await this.loadImpacts();
  };
}
